import { Container, Row } from "reactstrap";
import { ActiveDisablePageTitle, BonusUi, DefaultPaginationTitle, IconPaginationTitle, PaginationSizeTitle, PaginationTitle, RoundedPaginationTitle } from "../../../constants";
import { ActiveDisableSubTitle, DefaultPageData, DefaultPageSubTitle, IconListData, IconPageSubTitle, PageSizeSubTitle, PaginationAlignData, PaginationSizeData, RoundedListData, RoundedPageSubTitle } from "../../../data/bonusUi/Pagination";
import CommonPagination from "./common/CommonPagination";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const PaginationContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={PaginationTitle} parent={BonusUi} />
      <Container fluid>
        <Row>
          <CommonPagination title={DefaultPaginationTitle} span={DefaultPageSubTitle} data={DefaultPageData} pageColor="primary" />
          <CommonPagination title={ActiveDisablePageTitle} span={ActiveDisableSubTitle} data={DefaultPageData} pageColor="success" active disabled />
          <CommonPagination title={IconPaginationTitle} span={IconPageSubTitle} data={IconListData} pageColor="secondary" />
          <CommonPagination title={RoundedPaginationTitle} span={RoundedPageSubTitle} data={RoundedListData} pageColor="dark" classLink="rounded-circle" listClass="gap-2" />
          <CommonPagination title={RoundedPaginationTitle} span={RoundedPageSubTitle} multiData={PaginationAlignData} colClass="col-xl-6" />
          <CommonPagination title={PaginationSizeTitle} span={PageSizeSubTitle} multiData={PaginationSizeData} colClass="col-xl-6" />
        </Row>
      </Container>
    </>
  );
};
export default PaginationContainer;
